import React, { useCallback, useRef } from 'react';
import useTracking from './useTracking';

export default function useDebugMouseEventTracking() {
  const { trackMouseDown, trackMouseUp } = useTracking();
  const moved = useRef(false);
  const startTarget = useRef<string>();

  const handleMouseMove = useCallback(() => {
    moved.current = true;
    document.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const handleMouseUp = useCallback(
    (event: MouseEvent) => {
      trackMouseUp({
        startTarget: startTarget.current ?? 'unknown',
        isMovedFromStart: moved.current,
        target:
          event.target instanceof HTMLElement
            ? event.target.classList.toString()
            : 'unknown',
      });

      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('mousemove', handleMouseMove);
    },
    [trackMouseUp, handleMouseMove],
  );

  const handleMouseDown = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      startTarget.current = event?.currentTarget.classList.toString();

      trackMouseDown({
        target: startTarget.current,
      });

      moved.current = false;

      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    },
    [trackMouseDown, handleMouseMove, handleMouseUp],
  );

  return {
    onMouseDown: handleMouseDown,
  };
}
